import { TableCell } from '@repo/go-table';
import type { GridRenderCellParams } from '@repo/go-table';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import type { TAlertRule } from '../../types';
import type { AlertRulesValidationService } from '../services/AlertRulesValidationService';

type Props = {
  params: GridRenderCellParams;
  validationService: AlertRulesValidationService;
};

export const AlertCell = observer<Props>(function AlertCell({ params, validationService }) {
  const { t } = useTranslation();

  const errors = validationService.errors
    .get(params.id as string)
    ?.[params.field as keyof TAlertRule]?.map((error: string) => <p key={error}>{t(error)}</p>);

  return (
    <TableCell
      style={{
        backgroundColor: (!!errors?.length && 'var(--go-table-cell-error-bg-color)') || undefined,
      }}
      message={errors?.length ? errors : undefined}
    >
      {params.formattedValue}
    </TableCell>
  );
});
